// extracted by mini-css-extract-plugin
export var component = "SignpostsWithSubSectionLinks-module--component--564da";
export var fadePop = "SignpostsWithSubSectionLinks-module--fade-pop--f6b5c";
export var grid = "SignpostsWithSubSectionLinks-module--grid--bdf8e";
export var growHeightIn = "SignpostsWithSubSectionLinks-module--grow-height-in--ec44f";
export var items = "SignpostsWithSubSectionLinks-module--items--2f56e";